import { onErrorResetAndRery } from './middleware';
export const PERSIST_IDLE_TIMEOUT_MS = 250;
export const CATALOGUE_FIELD_TYPE = 'IMA:MEDIA_NODES';
export default (persistKey, options = {}) => {
    const dropCatalogue = options.dropCatalogue === true;
    const replacer = (key, value) => {
        if (key === 'isLoading' || key === 'error') {
            return undefined;
        }
        if (dropCatalogue && key === CATALOGUE_FIELD_TYPE) {
            return undefined;
        }
        return value;
    };
    const loadState = () => {
        try {
            const serialState = localStorage.getItem(persistKey);
            if (serialState === null) {
                return undefined;
            }
            return JSON.parse(serialState);
        }
        catch (err) {
            return undefined;
        }
    };
    const saveState = (state) => {
        if (typeof window === 'undefined') {
            return;
        }
        try {
            localStorage.setItem(persistKey, JSON.stringify(state, replacer));
        }
        catch (err) {
            console.error(err);
        }
    };
    const persistState = (store) => {
        let dirty = false;
        let idleHandle;
        let timerHandle;
        const idleWindow = (typeof window === 'undefined' ? undefined : window);
        const requestIdle = typeof idleWindow?.requestIdleCallback === 'function'
            ? idleWindow.requestIdleCallback.bind(idleWindow)
            : undefined;
        const cancelIdle = typeof idleWindow?.cancelIdleCallback === 'function'
            ? idleWindow.cancelIdleCallback.bind(idleWindow)
            : undefined;
        const cancelScheduled = () => {
            if (idleHandle !== undefined) {
                cancelIdle?.(idleHandle);
                idleHandle = undefined;
            }
            if (timerHandle !== undefined) {
                clearTimeout(timerHandle);
                timerHandle = undefined;
            }
        };
        const flush = () => {
            cancelScheduled();
            if (!dirty) {
                return;
            }
            dirty = false;
            saveState(store.getState());
        };
        const schedule = () => {
            dirty = true;
            if (idleHandle !== undefined || timerHandle !== undefined) {
                return;
            }
            if (requestIdle) {
                idleHandle = requestIdle(() => {
                    idleHandle = undefined;
                    flush();
                }, { timeout: PERSIST_IDLE_TIMEOUT_MS });
                return;
            }
            timerHandle = setTimeout(() => {
                timerHandle = undefined;
                flush();
            }, PERSIST_IDLE_TIMEOUT_MS);
        };
        saveState(store.getState());
        store.subscribe(schedule);
        const onVisibilityChange = () => {
            if (typeof document === 'undefined' ||
                document.visibilityState === 'hidden') {
                flush();
            }
        };
        const onPageHide = () => {
            flush();
        };
        if (typeof document !== 'undefined') {
            document.addEventListener('visibilitychange', onVisibilityChange);
        }
        if (typeof window !== 'undefined') {
            window.addEventListener('pagehide', onPageHide);
        }
        const resetState = (payload) => {
            cancelScheduled();
            dirty = false;
            localStorage.removeItem(persistKey);
            store.dispatch({
                type: 'RESET_STATE',
                payload
            });
        };
        return { resetState, flush };
    };
    const persistMiddleware = [onErrorResetAndRery(persistKey)];
    return {
        loadState,
        saveState,
        persistState,
        persistMiddleware
    };
};
